module.exports = __webpack_public_path__ + "static/img/pin-multi-scheduled-mandatory.aba2f4f.svg";